import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { MatomoQueue, getMatomoConfig } from '../config/runtime-config';

@Injectable({ providedIn: 'root' })
export class MatomoService {
  private readonly document = inject(DOCUMENT);
  private readonly router = inject(Router);
  private initialized = false;

  init(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    const config = getMatomoConfig();
    const windowRef = this.document.defaultView;
    if (!config || !windowRef) {
      return;
    }

    const queue = (windowRef._paq ??= []);
    queue.push(['setTrackerUrl', `${config.matomoUrl}/matomo.php`]);
    queue.push(['setSiteId', config.matomoSiteId]);
    queue.push(['enableLinkTracking']);

    this.ensureScript(`${config.matomoUrl}/matomo.js`);

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.trackPage(queue, event.urlAfterRedirects));

    if (this.router.navigated) {
      this.trackPage(queue, this.router.url);
    }
  }

  private ensureScript(src: string): void {
    if (this.document.querySelector('script[data-fluxtail-matomo="true"]')) {
      return;
    }

    const script = this.document.createElement('script');
    script.async = true;
    script.src = src;
    script.dataset['fluxtailMatomo'] = 'true';
    this.document.head.appendChild(script);
  }

  private trackPage(queue: MatomoQueue, url: string): void {
    const windowRef = this.document.defaultView;
    if (!windowRef) {
      return;
    }

    queue.push(['setCustomUrl', new URL(url, windowRef.location.origin).toString()]);
    queue.push(['setDocumentTitle', this.document.title]);
    queue.push(['trackPageView']);
  }
}
